import { render, staticRenderFns } from "./RatingAnswersList.vue?vue&type=template&id=3590860a&scoped=true"
import script from "./RatingAnswersList.vue?vue&type=script&lang=js"
export * from "./RatingAnswersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3590860a",
  null
  
)

export default component.exports